import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SendEmailDialogComponent} from './send-email-dialog.component';
import {DialogModule} from '../../../../../common/dialog/dialog.module';
import {SendEmailModule} from '../send-email/send-email.module';
import {ButtonModule} from "../../../../../core/component/button/button.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        FormsModule,
        ReactiveFormsModule,
        DialogModule,
        SendEmailModule,
        ButtonModule,
    ],
    declarations: [
        SendEmailDialogComponent,
    ],
    exports: [
        SendEmailDialogComponent
    ],
})
export class SendEmailDialogModule {
}
